import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementBlock as _createElementBlock, resolveDynamicComponent as _resolveDynamicComponent, withCtx as _withCtx, Fragment as _Fragment } from "vue"

const _hoisted_1 = { key: 1 }

import Dialog from 'primevue/dialog';
import { useLoadingStore } from './stores/LoadingStore';
import { useDialogStore } from './stores/DialogStore';


export default /*#__PURE__*/_defineComponent({
  __name: 'App',
  setup(__props) {

const loadingStore = useLoadingStore();
const dialogStore = useDialogStore();

function onCloseDialog(){
  console.log('closing dialog');
  dialogStore.closeDialog();
}


return (_ctx: any,_cache: any) => {
  const _component_router_view = _resolveComponent("router-view")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    (_unref(loadingStore).initLoadingDone)
      ? (_openBlock(), _createBlock(_component_router_view, { key: 0 }))
      : (_openBlock(), _createElementBlock("p", _hoisted_1, "Loading")),
    (_unref(dialogStore).isVisible)
      ? (_openBlock(), _createBlock(_unref(Dialog), {
          key: 2,
          visible: _unref(dialogStore).isVisible,
          header: _unref(dialogStore).header!,
          "dismissable-mask": "",
          modal: "",
          closable: "",
          "onUpdate:visible": _cache[0] || (_cache[0] = ($event: any) => (onCloseDialog()))
        }, {
          default: _withCtx(() => [
            (_unref(dialogStore).component)
              ? (_openBlock(), _createBlock(_resolveDynamicComponent(_unref(dialogStore).component), {
                  key: 0,
                  props: _unref(dialogStore).props,
                  onClose: _unref(dialogStore).closeDialog
                }, null, 40, ["props", "onClose"]))
              : _createCommentVNode("", true)
          ]),
          _: 1
        }, 8, ["visible", "header"]))
      : _createCommentVNode("", true)
  ], 64))
}
}

})